import { useDispatch, useSelector } from 'react-redux';
import { signOutStaffFailure, signOutStaffStart, signOutStaffSuccess } from '../redux/staff/staffSlice';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import ArticleIcon from '@mui/icons-material/Article';
import CategoryIcon from '@mui/icons-material/Category';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import PeopleIcon from '@mui/icons-material/People';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "../styles/App.css";
import { AccordionActions, Box, TableBody, TableContainer, TableRow, TableCell, Table, TableHead, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Modal from '@mui/material/Modal';
import Popover from '@mui/material/Popover';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeIcon from '@mui/icons-material/Mode';
import { useRef } from 'react';
import ReactModal from 'react-modal';


import { Container, TextField } from "@mui/material";
import CategoryCardM from "../components/CategoryCardM";
import chipsJPG from '../chips1.jpg';


import CircularProgress from '@mui/material/CircularProgress';
import CategoryMenu from "../components/CategoryMenu.jsx";
import * as ApiCall from '../ApiCall.jsx';
import EditMenu from './EditMenu.jsx';

import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';



export default function Profile() {

  const dispatch = useDispatch();
  const { currentStaff } = useSelector((state) => state.staff);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      dispatch(signOutStaffStart());
      const res = await fetch('/sign-out');
      const data = await res.json();
      if (data.success === false) {
        dispatch(signOutStaffFailure(data.message));
        return;
      }
      dispatch(signOutStaffSuccess(data));
    } catch (err) {
      dispatch(signOutStaffFailure(err.message));
    }
  }

  return (
    <>
      <div className="center-container">
        
        <h1>Profile</h1>
        <h3>Hi Employee: {currentStaff.employee_id}</h3>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSignOut}
          sx={{backgroundColor:'black',
          ':hover': {
            color: 'white',
            bgcolor: 'grey'
          }}}
        >
          Sign Out
        </Button>
      </div>
      {
        currentStaff.position === "manager" && ( <ManagerView /> )
      }
    </>
  )
};


export function ManagerView() {

  // be able to add, order or delete categories in a menu
  // be able to add, order or delete items in a category
  // be able to add or delete ingredients in an item

  // const getKeyByValue = (obj, value) => {
  //   return Object.keys(obj).find(key =>
  //     obj[key] === value);
  // };

  const navigate = useNavigate();
  const [clickSwitch, setClickSwitch] = useState(false);
  const [categories, setCategories] = useState({});
  const [dishes, setDishes] = useState({});
  const [ingredients, setIngredients] = useState({});
  const [feedback, setFeedback] = useState(null);

  const handleButtonClick = () => {
    setClickSwitch(true);
  };

  useEffect(() => {
    if (clickSwitch) {
      navigate('/employee-management');
    }
  }, [clickSwitch]);

  // Menu Logic
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => setOpenMenu(true);
  const handleCloseMenu = () => setOpenMenu(false);
  const styleMenu = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const [menuFormData, setMenuFormData] = useState({});
  const handleMenuChange = (e) => {
    setMenuFormData({ ...menuFormData, [e.target.id]: e.target.value })
  };
  const [addCategoryImage, setAddCategoryImage] = useState(null);
  const handleMenuImageChange = (e) => {
    setAddCategoryImage(e.target.files[0]);
    setMenuFormData({ ...menuFormData, "imagePath": "images/categories/" + e.target.files[0].name })
  };
  const handleMenuSubmit = async (e) => {
    e.preventDefault();
    try {
      if (addCategoryImage) {
        const res = await fetch(`/menu/add_category`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(menuFormData),
        });
  
        const data = await res.json();
  
        // Add image to firebase
        const urlCategory = menuFormData.imagePath
        const storageRef = ref(storage, urlCategory);
        try {
          await uploadBytes(storageRef, addCategoryImage);
          alert('Photo uploaded successfully!');
        } catch (error) {
          console.error('Error uploading file:', error);
          alert('Failed to upload file!');
        }

        // Add to category photos
        // const dataImage = await fetch(`/menu/add_category_image?imageURL=${urlCategory}&categoryName=${categoryName}`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        // })

        // const resImage = await dataImage.json();
  
        handleCloseMenu();
        handleGetCategories();
        setPopupTitle("Success!");
        setPopupText("Category has been added.");
        setPopupOpen(true);
      } else {
        alert('Please select a file.');
      }
    } catch(err) {
      console.log(err.message)
      setPopupTitle("Failed");
      setPopupText("Category has not been added. Please try again");
      setPopupOpen(true);
    }
  };
  const handleMenuDelete = async (e) => {
    const newCategories = categories.filter(category => 
      category.position !== e
    )
    setCategories(newCategories);
    
    try {
      const res = await fetch(`/menu/delete_category/${e}`, {
        method: 'DELETE',
      })
    } catch (err) {
      console.log(err.message);
    }
    window.location.reload();
  };
  // TODO when edit routes are done
  const [openEditCategory, setOpenEditCategory] = useState(false);
  const [selectedEditCategory, setSelectedEditCategory] = useState(null);
  const handleOpenEditCategory = (e) => {
    setOpenEditCategory(true); 
    
    const selectedCategory = categories.find(category => {
      if (category.position === e) { return true; }
    })
    
    setEditCategoryFormData({
      'name': selectedCategory.name,
      'id': selectedCategory.id,
      'imagePath': selectedCategory.imagePath,
      'description': selectedCategory.description,
      'position': selectedCategory.position,
    })

    setSelectedEditCategory(selectedCategory);
  }
  const handleCloseEditCategory = () => setOpenEditCategory(false);
  const [editCategoryFormData, setEditCategoryFormData] = useState({});
  const handleEditCategoryChange = (e) => {
    setEditCategoryFormData({ ...editCategoryFormData, [e.target.id]: e.target.value })
  };
  const [categoryImage, setCategoryImage] = useState(null);
  const onCategoryFileChange = (e) => {
    setCategoryImage(e.target.files[0]);
    setEditCategoryFormData({ ...editCategoryFormData, "imagePath": "images/categories/" + e.target.files[0].name })
  };
  const handleEditCategorySubmit = async (e) => {
    e.preventDefault();
    try {
      
      const res = await fetch(`/menu/edit_category/${selectedEditCategory.position}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editCategoryFormData),
      });

      const data = await res.json();

      // upload to category directory in firebase
      if (categoryImage) {
        const urlCategory = editCategoryFormData.imagePath;
        const storageRef = ref(storage, urlCategory);
        try {
          await uploadBytes(storageRef, categoryImage);
          alert('Photo uploaded successfully!');
        } catch (error) {
          console.error('Error uploading file:', error);
          alert('Failed to upload file!');
        }
      }

      handleCloseEditCategory();
      handleGetCategories();
      setPopupTitle("Success!");
      setPopupText("Category has been editted.");
      setPopupOpen(true);
    } catch(err) {
      console.log(err.message)
      setPopupTitle("Failed");
      setPopupText("Category has not been editted. Please try again");
      setPopupOpen(true);
    }
  };

  // Dishes Logic
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedDish, setSelectedDish] = useState('');
  const [selectedIngredient, setSelectedIngredient] = useState('');
  const [allIngredients, setAllIngredients] = useState('');
  const handleChangeCategorySelected = (e) => {
    setSelectedCategory(e.target.value);
  };
  const handleChangeDishSelected = (e) => {
    setSelectedDish(e.target.value);
  };
  const handleChangeIngredientSelected = (e) => {
    setSelectedIngredient(e.target.value);
  }
  useEffect(() => {
    const getDishes = async () => {
      const data = await fetch(`/menu/dishes/${selectedCategory}`);
      const result = await data.json();
      setDishes(result); 
    };

    if (selectedCategory !== '') {
      getDishes();
    }
  }, [selectedCategory]);
  useEffect(() => {

    const addExistingIngredient = async () => {
     
      const allSelectIngredientInfo = allIngredients.find(curr => {
        if (curr.id === selectedIngredient) { return true; }
      });

      const newIngredients = [...ingredients, allSelectIngredientInfo];
      setIngredients(newIngredients);

      // Add new ingredient ID to dish ingredient list
      const ingredientsForBackend = ingredients.map(obj => obj['id'])
      const newIngredientAdded = ingredientsForBackend.concat(selectedIngredient);      

      let dishData = dishes.find(dish => {
        if (dish.position === selectedDish) {
          return true;
        }
      })

      dishData.ingredients = newIngredientAdded;
      dishData.available_extras = newIngredientAdded;

      if (dishData.hasOwnProperty('ingredients')) {
        dishData.ingredients_list = dishData.ingredients;
        delete dishData.ingredients;
      }
      if (dishData.hasOwnProperty('available_extras')) {
        dishData.available_extras_list = dishData.available_extras;
        delete dishData.available_extras;
      }

      const {id, position, ...newDishData} = dishData;
      
      const result = await fetch(`/menu/edit_dish/${selectedCategory}/${selectedDish}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newDishData),
      })
    }

    if (selectedIngredient !== '') {
      addExistingIngredient();
    }
  }, [selectedIngredient])
  useEffect(() => {
    const getIngredients = () => {
      dishes && dishes.length > 0 &&
        dishes.find((dish) => {
          if (dish.position === selectedDish) {
            setIngredients(dish.ingredients);
            return true;
          }
      })
    };

    if (selectedDish !== '') {
      getIngredients();
    }
  }, [selectedDish]);

  // Ingredient Logic
  const handleIngredientDelete = (idd) => {
    const newIngredients = ingredients.filter(ingredient => ingredient.id !== idd)
    setIngredients(newIngredients)
    const ingredientsForBackend = newIngredients.map(obj => obj['id'])

    let dishData = dishes.find(dish => {
      if (dish.position === selectedDish) {
        return true;
      }
    })

    dishData.ingredients = ingredientsForBackend;
    dishData.available_extras = ingredientsForBackend;

    if (dishData.hasOwnProperty('ingredients')) {
      dishData.ingredients_list = dishData.ingredients;
      delete dishData.ingredients;
    }
    if (dishData.hasOwnProperty('available_extras')) {
      dishData.available_extras_list = dishData.available_extras;
      delete dishData.available_extras;
    }

    const {id, position, ...newDishData} = dishData;

    const editIngredients = async () => {
      const data = await fetch(`/menu/edit_dish/${selectedCategory}/${selectedDish}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newDishData),
      })
    }

    editIngredients();
  }

  const [openIngredient, setOpenIngredient] = useState(false);
  const handleOpenNewIngredient = () => setOpenIngredient(true);
  const handleCloseNewIngredient = () => setOpenIngredient(false);
  const [openExistingIngredient, setOpenExistingIngredient] = useState(false);
  const handleOpenExistingIngredient = async () =>  {
    const data = await fetch('/menu/get_all_ingredients', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const res = await data.json();
    setAllIngredients(res);
    setOpenExistingIngredient(true);
  }
  const handleCloseExistingIngredient = () => setOpenExistingIngredient(false);
  const [ingredientFormData, setIngredientFormData] = useState({});
  const handleNewIngredientChange = (e) => {
    setIngredientFormData({ ...ingredientFormData, [e.target.id]: e.target.value });
  };
  const handleNewIngredientSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`/menu/add_ingredient`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ingredientFormData),
      });

      const data = await res.json();
      const newIngredientId = data.id;

      // Add new ingredient ID to dish ingredient list
      const ingredientsForBackend = ingredients.map(obj => obj['id'])
      const newIngredientAdded = ingredientsForBackend.concat(newIngredientId);      

      let dishData = dishes.find(dish => {
        if (dish.position === selectedDish) {
          return true;
        }
      })

      dishData.ingredients = newIngredientAdded;
      dishData.available_extras = newIngredientAdded;

      if (dishData.hasOwnProperty('ingredients')) {
        dishData.ingredients_list = dishData.ingredients;
        delete dishData.ingredients;
      }
      if (dishData.hasOwnProperty('available_extras')) {
        dishData.available_extras_list = dishData.available_extras;
        delete dishData.available_extras;
      }

      const {id, position, ...newDishData} = dishData;
      
      const result = await fetch(`/menu/edit_dish/${selectedCategory}/${selectedDish}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newDishData),
      })

      const newIngredientObject = {...ingredientFormData, id: newIngredientId}
      const newIngredients = [...ingredients, newIngredientObject];
      setIngredients(newIngredients);

      handleCloseNewIngredient();
    } catch(err) {
      console.log(err.message)
    }
  };

  // Increment/decrement category logic
  const handleIncrementCategory = async (position) => {
    try {
      const data = await fetch(`/menu/increment_category/?position=${position}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      handleGetCategories();
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleDecrementCategory = async (position) => {
    try {
      const data = await fetch(`/menu/decrement_category/?position=${position}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      handleGetCategories();
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleGetCategories = async () => {
    const getCategories = async () => {
      const data = await fetch('/menu');
      const result = await data.json();
      setCategories(result); 
    };

    getCategories();
  }

  useEffect(() => {
    handleGetCategories();
  }, [])

  const test = {
    thumbnail: chipsJPG,
    name: "Starters",
    description: "Starters do starting"
  }


  const numbers = [1, 2, 3];


  const [popupOpen, setPopupOpen] = useState(false);
  const [popupText, setPopupText] = useState("Hi");
  const [popupTitle, setPopupTitle] = useState("Hi");

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

    const popupStyling = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      boxShadow: '0px 0px 1px',
      borderRadius: '8px',
      padding: '23px',
      backgroundColor: '#fff',
      maxWidth: '400px',
      width: '90%',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
  };

  const buttonStyling = {
   backgroundColor: "black",
   color: "white",
   width: "100px",
   height: "30px",

   borderRadius: '4px',
  }

  const categoryStyles = {
    tableContainer: {
      maxHeight: 400,
      overflow: 'auto',
    },
    tableHeadCell: {
      backgroundColor: 'black',
      color: 'white',
      fontWeight: 'bold',
    },
    tableRow: {
      '&:nth-of-type(odd)': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    button: {
      margin: '0.2rem',
    },
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
    },
  };
  const fetchImageUrl = async (path) => {
    const storageRef = ref(storage, path);
  
    try {
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };

  const [categoryImages, setCategoryImages] = useState({});
  const get_all_category_images = async () => {
    let mappedUrls = {}
    for (let i in categories) {
      mappedUrls[categories[i].name] = await fetchImageUrl(categories[i].imagePath);
    }
    setCategoryImages(mappedUrls);
  };
  useEffect(() => {
    get_all_category_images();
  }, [categories])

  return (
    <div>
      <ReactModal
          isOpen={popupOpen}
          onRequestClose={closePopup}
          contentLabel="Example Modal"
          style={popupStyling}
        >
          <h1>{popupTitle}</h1>
          <p>{popupText}</p>
          <button onClick={closePopup} style={buttonStyling}>CLOSE</button>
        </ReactModal>
      <div className="center-container">
        
        <h1>Manager Portal</h1>
        <Button
          variant="outlined"
          onClick={handleButtonClick}
          style={{marginBottom: '10px'}}
          sx={{color:'black', borderColor:'black'}}
        >
          <PeopleIcon />
          Employee Management
        </Button>
      </div>
      <div style={{padding: '25px'}}>
        {/* menu */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            onClick={handleGetCategories}
          >
            <h2>
              <ArticleIcon />
              Menu
            </h2>
          </AccordionSummary>

          {/* Pop up Menu Add */}
          <Modal
            open={openMenu}
            onClose={handleCloseMenu}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={styleMenu}>
              <h3>Add a Category</h3>
              <form onSubmit={handleMenuSubmit}>
                <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                  id='name'
                  placeholder='Name'
                  onChange={handleMenuChange}
                />
                <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                  id='description'
                  placeholder='Description'
                  onChange={handleMenuChange}
                />
                {/* <input
                  id='imagePath'
                  placeholder='Image Path'
                  onChange={handleMenuChange}
                /> */}
                <input 
                  id='image'
                  onChange={handleMenuImageChange}
                  type="file"
                />
                <br></br>
                <Button
                  type='submit'
                  variant='contained'
                  sx={{
                    mt: '10px',
                    bgcolor:'black',
                    color:'white',
                    mb: '10px',
                    '&:hover': {
                      backgroundColor: '#777778',
                    }
                  }}
                >
                  Add
                </Button>
              </form>
              {/* <Popover>

              </Popover> */}
            </Box>
          </Modal>
          <AccordionDetails>
          <Button 
            variant='contained'
            onClick={handleOpenMenu}
            sx={{
              bgcolor:'black',
              color:'white',
              mb: '10px',
              '&:hover': {
                backgroundColor: '#777778',
              }
            }}
          >
            Add Category
          </Button>
            <div style={{overflow: 'auto'}}>
            {
              categories && categories.length > 0 &&
                <Box sx={{ height: 400, width: '100%' }}>
                  <TableContainer sx={categoryStyles.tableContainer}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={categoryStyles.tableHeadCell}><h2></h2></TableCell>
                          <TableCell sx={categoryStyles.tableHeadCell}><h2>Name</h2></TableCell>
                          <TableCell sx={categoryStyles.tableHeadCell} ><h2>Description</h2></TableCell>
                          <TableCell sx={categoryStyles.tableHeadCell}><h2>Image</h2></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          categories.map((category) =>(
                            <TableRow sx={categoryStyles.tableRow}
                              key={category.position}
                            >
                              <TableCell sx={{}}>
                                <h4>
                                  <div style={{padding: '2px'}}>
                                  </div>
                                  {/* {category.position} */}
                                  <Button
                                    style={categoryStyles.button}
                                    onClick={() => handleIncrementCategory(category.position)}
                                    sx={{
                                      color:'black',
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                        transform: 'scale(1.3)',
                                        transition: 'transform 0.3s'
                                      }
                                    }}
                                  >
                                    ↑
                                  </Button>
                                  <Button
                                    style={categoryStyles.button}
                                    onClick={() => handleDecrementCategory(category.position)}
                                    sx={{
                                      color:'black',
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                        transform: 'scale(1.3)',
                                        transition: 'transform 0.3s'
                                      }
                                    }}
                                  >
                                    ↓
                                  </Button>
                                  <Button
                                    id={category.position}
                                    sx={{
                                      color:'black',
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                        transform: 'scale(1.3)',
                                        transition: 'transform 0.3s'
                                      }
                                    }}
                                    onClick={() => {
                                      // handleMenuEdit(category.position);
                                      handleOpenEditCategory(category.position);
                                    }}
                                  >
                                    <ModeIcon />
                                  </Button>
                                  <Modal
                                    open={openEditCategory}
                                    onClose={handleCloseEditCategory}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                  >
                                    <Box sx={styleMenu}>
                                      <h3>Edit Category</h3>
                                      <form onSubmit={handleEditCategorySubmit}>
                                        <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                                          id='name'
                                          value={editCategoryFormData.name}
                                          onChange={handleEditCategoryChange}
                                        />
                                        <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                                          id='description'
                                          value={editCategoryFormData.description}
                                          onChange={handleEditCategoryChange}
                                        />
                                        <input
                                          id='image'
                                          onChange={onCategoryFileChange}
                                          type="file"
                                        />
                                        <Button
                                          type='submit'
                                          variant='contained'
                                          sx={{
                                            bgcolor:'black',
                                            color:'white',
                                            mb: '10px',
                                            '&:hover': {
                                              backgroundColor: '#777778',
                                            }
                                          }}
                                        >
                                          Submit
                                        </Button>
                                      </form>
                                      {/* <Popover>

                                      </Popover> */}
                                    </Box>
                                  </Modal>
                                  <Button
                                    id={category.position}
                                    onClick={() => handleMenuDelete(category.position)}
                                    sx={{
                                      color:'black',
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                        transform: 'scale(1.3)',
                                        transition: 'transform 0.3s'
                                      }
                                    }}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </h4>
                              </TableCell>
                              <TableCell>{category.name}</TableCell>
                              <TableCell className='ellipsis'>{category.description}</TableCell>
                              <TableCell>
                                <img
                                  src={categoryImages[category.name]}
                                  alt={category.name} 
                                  style={{ width: '180px', height: '150px' }}
                                />
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
            }
            </div>
          </AccordionDetails>
          <AccordionActions>
            {/* <Button variant='outlined'>Submit</Button> */}
          </AccordionActions>
        </Accordion>

        {/* category */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <h2>
              <CategoryIcon />
              Category
              <>  
              </>
            </h2>
          </AccordionSummary>
          <AccordionDetails>
              {/* <Container sx={{display: 'flex', justifyContent: 'center',  flexDirection: 'column', flexWrap: 'wrap'}}>
                  {
                    numbers.map((dishes) => (
                      <CategoryCardM categoryInfo={test} ></CategoryCardM>
                      //need to input the category structs instead of just the test guy
                      //need to format this properly to display the cards nicely for different sized pages
                    ))
                  }
                </Container> */}
                <EditMenu categories={categories}></EditMenu>
          </AccordionDetails>
          {/* <AccordionActions>
            <Button variant='outlined'>Submit</Button>
          </AccordionActions> */}
        </Accordion>

        {/* dish */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            onClick={handleGetCategories}
          >
            <h2>
              <LocalDiningIcon />
              Dish
            </h2>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ minWidth: 120 }}>
              <FormControl  fullWidth>
                <InputLabel sx={{ml:"8px"}} id='category-select'>Select Category of Dish</InputLabel>
                <Select
                  labelId='category-select'
                  id='select'
                  value={selectedCategory}
                  label="Select Category of Dish"
                  onChange={handleChangeCategorySelected}
                  sx={{ml:"8px"}}
                >
                  {
                    categories && categories.length > 0 &&
                      categories.map((category) => (
                        <MenuItem
                          key={category.position}
                          value={category.position}
                        >
                          {category.name}
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </Box>
            <div style={{padding: '20px'}}></div>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth disabled={selectedCategory === ''}>
                <InputLabel sx={{ml:"8px"}} id='dish-select'>Select Dish</InputLabel>
                <Select
                  labelId='dish-select'
                  id='select-dish'
                  value={selectedDish}
                  label="Select Dish"
                  onChange={handleChangeDishSelected}
                  sx={{ml:"8px"}}
                >
                  {
                    dishes && dishes.length > 0 &&
                      dishes.map((dish) => (
                        <MenuItem
                          key={dish.position}
                          value={dish.position}
                        >
                          {dish.name}
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </Box>
            <div style={{overflow: 'auto'}}>
            {
              ingredients &&
                <Box sx={{ height: 400, width: '100%' }}>
                <Button 
                  variant='contained'
                  style={{margin: '10px'}}
                  onClick={handleOpenExistingIngredient}
                  sx={{
                    bgcolor:"black",
                    ml:"8px",
                    '&:hover': {
                      backgroundColor: '#777778',
                    }
                  }}
                >
                  Add Existing Ingredient
                </Button>
                <Button 
                  variant='contained'
                  style={{margin: '10px'}}
                  onClick={handleOpenNewIngredient}
                  sx={{
                    bgcolor:"black",
                    ml:"8px",
                    '&:hover': {
                      backgroundColor: '#777778',
                    }
                  }}
                >
                  Add New Ingredient
                </Button>
                {
                  openExistingIngredient && 
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                    <InputLabel id='ingredient-select'>Select Ingredient</InputLabel>

                    <Select
                      open={openExistingIngredient}
                      onClose={handleCloseExistingIngredient}
                      labelId='ingredient-select'
                      id='ingredient-select'
                      value={selectedIngredient}
                      label="Select Ingredient"
                      onChange={handleChangeIngredientSelected}
                    >
                      {
                        allIngredients && allIngredients.length > 0 &&
                          allIngredients.map((ingredient) => (
                            <MenuItem
                              key={ingredient.id}
                              value={ingredient.id}
                            >
                              {ingredient.name}
                            </MenuItem>
                          ))
                      }
                    </Select>
                    </FormControl>
                  </Box>
                }
                <Modal
                  open={openIngredient}
                  onClose={handleCloseNewIngredient}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={styleMenu}>
                    <h3>Add an Ingredient</h3>
                    <form onSubmit={handleNewIngredientSubmit}>
                      <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                        id='name'
                        placeholder='Name'
                        onChange={handleNewIngredientChange}
                      />
                      <TextField
              fullWidth
              margin="normal"
              variant="outlined"
                        id='cost'
                        placeholder='Cost'
                        onChange={handleNewIngredientChange}
                      />
                      <Button
                        type='submit'
                        variant='contained'
                        sx={{bgcolor:'black'}}
                      >
                        Add Ingredient
                      </Button>
                    </form>
                    {/* <Popover>

                    </Popover> */}
                  </Box>
                </Modal>
                  <TableContainer sx={{ml:"8px"}}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          {/* <TableCell><h2>ID</h2></TableCell> */}
                          <TableCell><h2>Name</h2></TableCell>
                          <TableCell><h2>Cost</h2></TableCell>
                          {/* <TableCell><h2>Image Path</h2></TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          ingredients.length > 0 && ingredients.map((ingredient) =>(
                            <TableRow
                              key={ingredient.id}
                            >
                              <TableCell>
                                <Button
                                  id={ingredient.id}
                                  onClick={() => handleIngredientDelete(ingredient.id)}
                                  sx={{
                                    color:'black',
                                    '&:hover': {
                                      backgroundColor: 'transparent',
                                      transform: 'scale(1.3)',
                                      transition: 'transform 0.3s'
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </Button>
                                {ingredient.name}
                              </TableCell>
                              <TableCell>
                                {ingredient.cost}
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
            }
            </div>
            
          </AccordionDetails>
        </Accordion>
      </div>
      
    </div>
  );
}